import React from 'react';

import './global.css'
import Routes from './routes';
// const App = () => <Routes/>

function App() {
  return (
    <Routes/>
  );
}

export default App;